import { useContext, useMemo } from 'react';
import _get from 'lodash/get';

import { AuthContext } from 'context/AuthContext';
import useStore from './useStore';

export default function useUserMetaData() {
  const { userData } = useContext(AuthContext);
  const {
    brand,
    isSSRStore,
    ssSellerId,
    merchantId,
    returnsMode,
    getStoreProperty,
  } = useStore();

  const storeName = getStoreProperty('store_name', '');

  return useMemo(() => {
    const userId = _get(userData, 'userId', '');
    const email = _get(userData, 'email', '');
    const firstName = _get(userData, 'firstName', '');
    const lastName = _get(userData, 'lastName', '');

    return {
      group_id: merchantId,
      cx_merchant_id: merchantId,
      customer_id: userId,
      brand,
      email,
      user_id: userId,
      name: `${firstName} ${lastName}`.trim(),
      first_name: firstName,
      last_name: lastName,
      user_role: 'SHOPPER',
      company_name: storeName,
      seller_id: ssSellerId,
      returns_mode: returnsMode,
      is_SSR_store: isSSRStore,
    };
  }, [
    brand,
    userData,
    merchantId,
    storeName,
    ssSellerId,
    returnsMode,
    isSSRStore,
  ]);
}
